.fc-yearview {
  border-collapse: collapse !important;
}
.fc-yearview .fc-day-col {
  width: 40px;
}
.fc-yearview th {
  overflow: hidden;
  padding: 2px 4px;
}
.fc-yearview th.fc-day {
  border-right: none;
  font-weight: bold;
  padding: 2px 0;
  position: relative;
  text-align: center;
}
.fc-yearview .fc-day-empty {
  border: none;
}
.fc-yearview .fc-day-today {
  background-color: var(--fc-today-bg-color);
}
.fc-yearview .fc-events {
  border-left: none;
  padding: 1px 2px 0 0;
  position: relative;
}
.fc-yearview .fc-event.fc-bg-event {
  border: none;
  margin: 0;
  z-index: -1;
}
.fc-yearview .fc-h-event {
  border-radius: 3px;
  font-size: var(--fc-small-font-size, 0.85em);
  margin: 1px 0 2px 0;
  overflow: hidden;
  padding: 1px 2px;
}
